import { render, staticRenderFns } from "./tuikuan.vue?vue&type=template&id=3581f68d"
import script from "./tuikuan.vue?vue&type=script&lang=js"
export * from "./tuikuan.vue?vue&type=script&lang=js"
import style0 from "./tuikuan.vue?vue&type=style&index=0&id=3581f68d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports